'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const Formatters=require('../../../dist-es6/client/formatters');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const AlertStatusCache=require('../../../dist-es6/client/viewModels/alertStatusCache');let

IncidentViewModel=function(){
function IncidentViewModel(time,incidentType,fatigue,statistics,viewScheduleFunc,timezone,id){var _this=this;_classCallCheck(this,IncidentViewModel);
_.ensureInstanceOf(Date,time);
_.ensureInstanceOf('string',incidentType.code);
_.ensureInstanceOf('string',incidentType.description);
_.ensureInstanceOf(['nullable','number'],fatigue);
_.ensureInstanceOf(['nullable','object'],statistics);
_.ensureInstanceOf(Function,viewScheduleFunc);
_.ensureInstanceOf('string',timezone);

this._time=time;
this._incidentType=incidentType;
this._fatigue=fatigue||null;
this._statistics=statistics||null;
this._viewSchedule=viewScheduleFunc;
this._timezone=timezone;
this._id=id;

this._statusCache=new AlertStatusCache(function(nt){return _this._thresholdStatusFor(nt)});
this._fatigueForDisplay=Math.floor(fatigue||0);

const[dayOfWeek,dateString,hourString]=Formatters.formatInLocale(this._time,
'ddd|YYYY-MM-DD|HH:00',
timezone,
{displayTimeZone:!1}).split('|');

this._buckets={dayOfWeek:dayOfWeek,dateString:dateString,hourString:hourString};
}IncidentViewModel.

createFrom=function createFrom(rawIncident,incidentType,timezone,viewScheduleFunc){
return new IncidentViewModel(
new Date(rawIncident.time),
incidentType,
rawIncident.fatigue,
rawIncident.statistics,
viewScheduleFunc,
timezone,
rawIncident.id);
};IncidentViewModel.prototype.













































viewSchedule=function viewSchedule(){
this._viewSchedule();
};IncidentViewModel.prototype.






thresholdFor=function thresholdFor(notificationType){
const effectiveThresholdMap=ThresholdStatus.getEffectiveThresholdsForMultipleGroups(this._currentlyScopedGroupMemberships,_.get(this.statistics,'recentHistory.fatigue'),[notificationType]);
return effectiveThresholdMap.get(notificationType);
};IncidentViewModel.prototype.

_thresholdStatusFor=function _thresholdStatusFor(notificationType){
return ThresholdStatus.fromScoreAndThreshold(this.fatigue,this.thresholdFor(notificationType));
};IncidentViewModel.prototype.

thresholdStatusFor=function thresholdStatusFor(notificationType){
return this._statusCache.get(notificationType);
};_createClass(IncidentViewModel,[{key:'id',get:function(){return this._id}},{key:'dayOfWeek',get:function(){return this._buckets.dayOfWeek}},{key:'hourString',get:function(){return this._buckets.hourString}},{key:'dateString',get:function(){return this._buckets.dateString}},{key:'timezone',get:function(){return this._timezone}},{key:'time',get:function(){return this._time}},{key:'code',get:function(){return this._incidentType.code}},{key:'description',get:function(){return this._incidentType.description}},{key:'fatigue',get:function(){return this._fatigue}},{key:'fatigueForDisplay',get:function(){return this._fatigueForDisplay}},{key:'statistics',get:function(){return this._statistics}},{key:'currentlyScopedGroupMemberships',set:function(value){this._statusCache.clear();this._currentlyScopedGroupMemberships=value}}]);return IncidentViewModel}();


module.exports=IncidentViewModel;
//# sourceMappingURL=incidentViewModel.js.map
